import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestLogInterceptor } from './request-log.interceptor';
import { RequestLogService } from './request-log.service';

export const requestLogProviders: any[] = [
  RequestLogService,
  {provide: HTTP_INTERCEPTORS, useClass: RequestLogInterceptor, multi: true}
];
